import React, { useReducer } from 'react';
import PropTypes from 'prop-types';

import Button from '@strava/ui/Button';
import cx from '@strava/ui/clsx';
import styles from './InviteFriendsButton.scss';
import { t } from '../../utils/InviteFriends.utils';
import InviteFriendsModal from '../InviteFriendsModal/InviteFriendsModal';
import InviteFriendsContext from '../../state/InviteFriendsContext';
import { reducer } from '../../state/InviteFriends.reducer';
import { OPEN_MODAL } from '../../state/InviteFriends.actions';

const InviteFriendsButton = ({ variant, googleClientId, mocked }) => {
  const [state, dispatch] = useReducer(reducer, {
    isModalOpen: false,
    googleClientId,
    mocked
  });

  const providerState = {
    state,
    dispatch
  };

  return (
    <InviteFriendsContext.Provider value={providerState}>
      <Button
        type="button"
        onClick={() => dispatch({ type: OPEN_MODAL })}
        variant={variant}
        className={cx(styles[variant])}
      >
        {t('cta')}
      </Button>

      {state.isModalOpen && <InviteFriendsModal />}
    </InviteFriendsContext.Provider>
  );
};

InviteFriendsButton.defaultProps = {
  mocked: false
};

InviteFriendsButton.propTypes = {
  variant: PropTypes.oneOf(['text', 'primary']).isRequired,
  googleClientId: PropTypes.string.isRequired,
  mocked: PropTypes.bool
};

export default InviteFriendsButton;
